import { ApiHelper } from "shared/helpers/api";
import { getUrl, ROUTES } from "shared/api/urls";

export const setGDPROption = (email: string, hasOptedForNewsletter: number) => {
    const url = getUrl(ROUTES.SET_GDPR);
    const body = { customerEmail: email, hasOptedForNewsletter: hasOptedForNewsletter };
    return ApiHelper(url, { method: "POST", body, isBodyJSON: true }).then((data: Response) =>
        data.json()
    );
};

export const updateCookieConsent = (consent: string) => {
    const body = { consent };
    const url = getUrl(ROUTES.SET_COOKIE_CONSENT);
    return ApiHelper(url, { method: "POST", body, isBodyJSON: true });
};
